"use client";

import { HeartIcon } from "~/components/icons/24/Heart";
import { Link } from "~/i18n/routing";
import { useWishlist } from "~/lib/hooks/useWishlist";
import styles from "../header.module.css";

export const WishlistTrigger = () => {
	const { ids } = useWishlist();

	return (
		<Link
			href={"/onskeliste"}
			className={`${styles.icon} ${styles.favourites} ${ids.length > 0 && styles.active}`}
		>
			<HeartIcon />
		</Link>
	);
};
